import { render, staticRenderFns } from "./fullReports.vue?vue&type=template&id=a638b9ce&scoped=true"
import script from "./fullReports.vue?vue&type=script&lang=js"
export * from "./fullReports.vue?vue&type=script&lang=js"
import style0 from "./fullReports.vue?vue&type=style&index=0&id=a638b9ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a638b9ce",
  null
  
)

export default component.exports